window.FlorenzaToast = (function () {
  var TOAST_ID = 'florenza-toast';
  var hideTimer = null;

  function getEl() {
    var el = document.getElementById(TOAST_ID);
    if (el) return el;

    el = document.createElement('div');
    el.id = TOAST_ID;
    el.className = 'cart-stock-toast';
    el.hidden = true;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = ''
      + '<p class="cart-stock-toast__title" data-florenza-toast-title></p>'
      + '<p class="cart-stock-toast__text" data-florenza-toast-text></p>';
    document.body.appendChild(el);
    return el;
  }

  function hide() {
    var el = document.getElementById(TOAST_ID);
    if (!el) return;
    el.classList.remove('is-visible');
    window.setTimeout(function () {
      if (!el.classList.contains('is-visible')) el.hidden = true;
    }, 200);
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function show(opts) {
    opts = opts || {};
    var el = getEl();
    var titleEl = el.querySelector('[data-florenza-toast-title]');
    var textEl = el.querySelector('[data-florenza-toast-text]');
    var title = opts.title || '';
    var text = opts.text || '';

    if (titleEl) {
      titleEl.textContent = title;
      titleEl.hidden = !title;
    }
    if (textEl) {
      textEl.textContent = text;
      textEl.hidden = !text;
    }

    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-visible');

    var duration = typeof opts.duration === 'number' ? opts.duration : 2500;
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, duration);
  }

  return { show: show, hide: hide };
})();

window.FlorenzaCartBadge = (function () {
  var lastCount = null;

  function pulse() {
    document.querySelectorAll('.js-number-cart, .enj-cartcount').forEach(function (el) {
      el.classList.remove('is-pulsing');
      void el.offsetWidth;
      el.classList.add('is-pulsing');
    });
  }

  function pulseIfCountChanged(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    if (lastCount === null || lastCount === count) {
      lastCount = count;
      return;
    }
    lastCount = count;
    pulse();
  }

  function markCount(count) {
    if (typeof count === 'number' && !isNaN(count)) lastCount = count;
  }

  function readCountFromDom() {
    var els = document.querySelectorAll('.enj-cartcount, .js-number-cart, [data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      var n = parseInt((els[i].textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n)) return n;
      n = parseInt(els[i].getAttribute('data-cart-count'), 10);
      if (!isNaN(n)) return n;
    }
    return 0;
  }

  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'florenza-cart-badge-pulse' && e.target && e.target.classList) {
      e.target.classList.remove('is-pulsing');
    }
  });

  return {
    pulse: pulse,
    pulseIfCountChanged: pulseIfCountChanged,
    markCount: markCount,
    readCountFromDom: readCountFromDom
  };
})();

function isFlorenzaMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function initAddToCartFeedback() {
  function productName(product) {
    if (!product) return '';
    return product.product_title || product.title || '';
  }

  if (window.FlorenzaCartBadge) {
    window.FlorenzaCartBadge.markCount(window.FlorenzaCartBadge.readCountFromDom());
  }

  function onItemAdded(product) {
    if (window.FlorenzaCartBadge) {
      window.FlorenzaCartBadge.markCount(window.FlorenzaCartBadge.readCountFromDom());
      window.FlorenzaCartBadge.pulse();
    }

    if (!isFlorenzaMobile() || !window.FlorenzaToast) return;
    var labels = window.florenza_cart_labels || {};
    window.FlorenzaToast.show({
      title: labels.added_success || '',
      text: productName(product),
      duration: 2500
    });
  }

  function onCartUpdated(cart) {
    if (!window.FlorenzaCartBadge || !cart || typeof cart.item_count !== 'number') return;
    window.FlorenzaCartBadge.pulseIfCountChanged(cart.item_count);
  }

  if (window.jQuery) {
    jQuery(document).on('cart:item-added', function (e, product) {
      onItemAdded(product);
    });
    jQuery(document).on('cart:updated', function (e, cart) {
      onCartUpdated(cart || (e.originalEvent && e.originalEvent.detail) || e.detail);
    });
    return;
  }

  document.addEventListener('cart:item-added', function (e) {
    onItemAdded(e.detail);
  });
  document.addEventListener('cart:updated', function (e) {
    onCartUpdated(e.detail);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const btnToggle = document.querySelector('.btn-toggle-description');
  const descriptionText = document.querySelector('.description-text');
  
  if (btnToggle && descriptionText) {
    btnToggle.addEventListener('click', function() {
      descriptionText.classList.toggle('expanded');
      btnToggle.textContent = descriptionText.classList.contains('expanded') ? 'Ver menos' : 'Ver mais';
    });
  }

  function faqToggle() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    if (faqQuestions.length === 0) return;
    
    faqQuestions.forEach(btn => {
      btn.addEventListener('click', function () {
        const answer = this.nextElementSibling;
        const arrow = this.querySelector('i');
        const isOpen = answer.classList.contains('open');
    
        if (isOpen) {
          answer.classList.remove('open');
          arrow.classList.add('rotate');
        } else {
          answer.classList.add('open');
          arrow.classList.remove('rotate');
        }
      });
    });
  };

  faqToggle();
  bindCartPageRemove();
  initCepPersistence();
  initMinicartFreeShipping();
  initCartPageAutoUpdate();
  initMinicartLoading();
  collectionFiltersDrawer();
  initProductCardImageFallback();
  initAddToCartFeedback();
});

/**
 * Remoção na /cart: delegação no document (capture).
 * O handler antigo no .page-cart deixava de funcionar se a seção fosse re-renderizada.
 */
function bindCartPageRemove() {
  if (window.__florenzaCartRemoveBound) return;
  window.__florenzaCartRemoveBound = true;

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (target && target.nodeType !== 1) target = target.parentElement;
    if (!target || typeof target.closest !== 'function') return;

    var removeBtn = target.closest('[data-remove-cart-item]');
    if (!removeBtn) return;
    if (!removeBtn.closest('.page-cart')) return;
    if (removeBtn.getAttribute('data-removing') === '1') return;

    var row = removeBtn.closest('tr.cart_item, tr');
    if (!row) return;

    e.preventDefault();
    e.stopPropagation();

    var rows = Array.prototype.slice.call(document.querySelectorAll('.page-cart tr.cart_item'));
    var line = rows.indexOf(row) + 1;
    if (line < 1) {
      line = parseInt(removeBtn.getAttribute('data-line') || row.getAttribute('data-cart-line'), 10);
    }
    if (!line || line < 1) return;

    removeBtn.setAttribute('data-removing', '1');
    row.style.opacity = '0.5';
    row.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.data) {
          window.location.href = removeBtn.getAttribute('href') || '/cart';
          return;
        }

        var cart = result.data;
        if (!cart.item_count) {
          window.location.reload();
          return;
        }

        var removedKey = removeBtn.getAttribute('data-key') || row.getAttribute('data-cart-key');
        if (removedKey) {
          var stillThere = (cart.items || []).some(function (item) { return item.key === removedKey; });
          if (stillThere) {
            window.location.href = '/cart/change?line=' + line + '&quantity=0';
            return;
          }
        }

        row.remove();

        Array.prototype.slice.call(document.querySelectorAll('.page-cart tr.cart_item')).forEach(function (el, index) {
          var n = String(index + 1);
          el.setAttribute('data-cart-line', n);
          var qty = el.querySelector('[data-cart-qty], .js-qty__num, .product-quantity input');
          if (qty) qty.setAttribute('data-line', n);
          var btn = el.querySelector('[data-remove-cart-item]');
          if (btn) {
            btn.setAttribute('data-line', n);
            btn.removeAttribute('data-removing');
            if (btn.tagName === 'A') {
              btn.setAttribute('href', '/cart/change?line=' + n + '&quantity=0');
            }
          }
        });

        var totalEl = document.querySelector('.page-cart .cart-amount .amount');
        if (totalEl && window.FlorenzaFreeShipping && FlorenzaFreeShipping.formatMoney) {
          totalEl.textContent = FlorenzaFreeShipping.formatMoney(cart.total_price);
        } else if (totalEl && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          totalEl.textContent = Shopify.formatMoney(cart.total_price);
        }

        document.querySelectorAll('.enj-cartcount, .cartCount, .js-number-cart, [data-cart-count]').forEach(function (el) {
          el.textContent = String(cart.item_count);
        });

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (typeof jQuery !== 'undefined') {
          jQuery(document).trigger('cart:updated', [cart]);
        }
      })
      .catch(function () {
        window.location.href = removeBtn.getAttribute('href') || '/cart';
      });
  }, true);
}

bindCartPageRemove();

/**
 * Substitui imagens quebradas/ausentes nos cards e na busca pelo placeholder padrão.
*/
function initProductCardImageFallback() {
  var template = document.getElementById('product-card-image-placeholder-template');
  if (!template) return;

  function applyFallback(img) {
    if (!img || img.dataset.fallbackApplied === '1') return;
    img.dataset.fallbackApplied = '1';

    var isSearch = !!img.closest('.product_info, .img_left');
    var wrap = document.createElement('span');
    wrap.className = 'product-card-image-wrap product-card-image-wrap--placeholder' + (isSearch ? ' product-card-image-wrap--search' : '');
    wrap.innerHTML = template.innerHTML.trim();

    var currentWrap = img.closest('.product-card-image-wrap');
    if (currentWrap) {
      currentWrap.replaceWith(wrap);
      return;
    }

    if (img.parentElement) {
      img.parentElement.replaceChild(wrap, img);
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-product-card-image], .product-card-image, .img-product img, .product_info img').forEach(function (img) {
      if (!img.getAttribute('src') || (img.complete && img.naturalWidth === 0)) {
        applyFallback(img);
      }
    });
  }

  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    if (!img.matches('[data-product-card-image], .product-card-image, .img-product img, .product_info img')) return;
    applyFallback(img);
  }, true);

  document.addEventListener('florenza:product-cards-updated', function () {
    scan(document.querySelector('.js_search_results'));
  });

  scan();
  window.FlorenzaProductCardImage = { scan: scan };
}

/**
 * Persiste CEP digitado na PDP (#zipcode / .input_cep) e no minicart,
 * para reutilizar na barra de frete grátis do /cart.
 */
function initCepPersistence() {
  var STORAGE_KEY = 'florenza_user_cep';
  var LEGACY_KEYS = ['florenza_fsb_cep'];

  function digits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(value) {
    var v = digits(value);
    if (v.length > 5) return v.slice(0, 5) + '-' + v.slice(5);
    return v;
  }

  function saveCep(value) {
    var cep = digits(value);
    if (cep.length !== 8) return;
    try {
      localStorage.setItem(STORAGE_KEY, cep);
      LEGACY_KEYS.forEach(function (k) {
        try { localStorage.setItem(k, cep); } catch (e) {}
      });
    } catch (e) {}
  }

  function readCep() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY) || '';
      if (digits(saved).length === 8) return digits(saved);
      for (var i = 0; i < LEGACY_KEYS.length; i++) {
        saved = localStorage.getItem(LEGACY_KEYS[i]) || '';
        if (digits(saved).length === 8) return digits(saved);
      }
    } catch (e) {}
    return '';
  }

  function isCepInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    return el.id === 'zipcode'
      || el.name === 'cep'
      || (el.classList && (el.classList.contains('input_cep') || el.classList.contains('minicart-frete-cep') || el.classList.contains('cart-fsb__cep-input')));
  }

  function bindInput(input) {
    if (!input || input.dataset.cepBound === '1') return;
    input.dataset.cepBound = '1';

    var saved = readCep();
    if (saved && !digits(input.value)) {
      input.value = formatCep(saved);
    }

    input.addEventListener('input', function () {
      input.value = formatCep(input.value);
      if (digits(input.value).length === 8) saveCep(input.value);
    });

    input.addEventListener('blur', function () {
      saveCep(input.value);
    });

    input.addEventListener('change', function () {
      saveCep(input.value);
    });
  }

  function scan() {
    document.querySelectorAll('#zipcode, input[name="cep"], .input_cep, .minicart-frete-cep, .cart-fsb__cep-input').forEach(bindInput);
  }

  scan();

  // App Frete no Produto pode injetar o input depois do load
  var observer = new MutationObserver(function () { scan(); });
  observer.observe(document.body, { childList: true, subtree: true });

  // Salva também ao clicar em CONSULTAR perto do input de CEP
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button, input[type="button"], input[type="submit"], a');
    if (!btn) return;
    var label = (btn.textContent || btn.value || '').trim().toLowerCase();
    if (label.indexOf('consultar') === -1 && label.indexOf('calcular') === -1) return;
    var scope = btn.closest('form, .frete-no-produto-container, [class*="frete"], .minicart-frete-calc, .cart-fsb') || document;
    var input = scope.querySelector('#zipcode, .input_cep, input[name="cep"], .minicart-frete-cep, .cart-fsb__cep-input');
    if (input) saveCep(input.value);
  }, true);

  window.FlorenzaCep = {
    key: STORAGE_KEY,
    read: readCep,
    save: saveCep,
    format: formatCep,
    digits: digits
  };
}

/**
 * Regras de frete grátis por UF (centavos) — política Florenza.
 */
window.FlorenzaFreeShipping = (function () {
  var THRESHOLDS = {
    SP: 16990,
    RJ: 23990,
    PR: 19990, SC: 19990, RS: 19990,
    MG: 19990, ES: 19990,
    MT: 26990, MS: 26990, GO: 26990, DF: 26990,
    AC: 49990, AM: 49990, AP: 49990, PA: 49990, RO: 49990, RR: 49990, TO: 49990,
    AL: 49990, BA: 49990, CE: 49990, MA: 49990, PB: 49990, PE: 49990, PI: 49990, RN: 49990, SE: 49990
  };

  function digits(raw) {
    return String(raw || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatMoney(cents) {
    return 'R$ ' + (Math.max(0, cents) / 100).toFixed(2).replace('.', ',');
  }

  function thresholdForUf(uf) {
    return THRESHOLDS[String(uf || '').toUpperCase()] || null;
  }

  function readCep() {
    if (window.FlorenzaCep && typeof window.FlorenzaCep.read === 'function') {
      return window.FlorenzaCep.read();
    }
    try {
      var a = localStorage.getItem('florenza_user_cep') || '';
      if (digits(a).length === 8) return digits(a);
      var b = localStorage.getItem('florenza_fsb_cep') || '';
      if (digits(b).length === 8) return digits(b);
    } catch (e) {}
    return '';
  }

  function saveCep(cep) {
    if (window.FlorenzaCep && typeof window.FlorenzaCep.save === 'function') {
      window.FlorenzaCep.save(cep);
      return;
    }
    cep = digits(cep);
    if (cep.length !== 8) return;
    try {
      localStorage.setItem('florenza_user_cep', cep);
      localStorage.setItem('florenza_fsb_cep', cep);
    } catch (e) {}
  }

  function compute(cartTotal, uf) {
    var threshold = thresholdForUf(uf);
    if (!threshold) return null;
    var remaining = Math.max(0, threshold - cartTotal);
    var progress = Math.min(100, Math.max(0, (cartTotal / threshold) * 100));
    return {
      threshold: threshold,
      remaining: remaining,
      progress: progress,
      qualified: remaining === 0,
      message: remaining === 0
        ? 'Parabéns! Você ganhou Frete Grátis'
        : 'Faltam ' + formatMoney(remaining) + ' para o Frete Grátis'
    };
  }

  function resolveUf(cep) {
    cep = digits(cep);
    if (cep.length !== 8) return Promise.reject(new Error('cep_invalido'));
    return fetch('https://viacep.com.br/ws/' + cep + '/json/', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (addr) {
        if (!addr || addr.erro || !addr.uf) throw new Error('cep_invalido');
        saveCep(cep);
        return addr.uf;
      });
  }

  return {
    digits: digits,
    formatMoney: formatMoney,
    thresholdForUf: thresholdForUf,
    readCep: readCep,
    saveCep: saveCep,
    compute: compute,
    resolveUf: resolveUf
  };
})();

function initMinicartFreeShipping() {
  var cache = { cep: '', uf: '' };

  function getRoot() {
    return document.querySelector('[data-minicart-fsb]');
  }

  function getCartTotal(root) {
    var fromAttr = parseInt(root.getAttribute('data-cart-total'), 10);
    if (!isNaN(fromAttr) && fromAttr >= 0) return fromAttr;
    return 0;
  }

  function renderPending(root, hint) {
    root.classList.add('minicart-fsb--pending');
    root.classList.remove('minicart-fsb--qualified');
    var track = root.querySelector('[data-minicart-fsb-track]');
    var hintEl = root.querySelector('[data-minicart-fsb-hint]');
    if (track) track.hidden = true;
    if (hintEl) {
      hintEl.hidden = false;
      hintEl.textContent = hint || 'Informe seu CEP abaixo para calcular o frete grátis';
    }
  }

  function renderBar(root, state) {
    root.classList.remove('minicart-fsb--pending');
    root.classList.toggle('minicart-fsb--qualified', state.qualified);
    var track = root.querySelector('[data-minicart-fsb-track]');
    var fill = root.querySelector('[data-minicart-fsb-fill]');
    var text = root.querySelector('[data-minicart-fsb-text]');
    var hintEl = root.querySelector('[data-minicart-fsb-hint]');
    if (hintEl) hintEl.hidden = true;
    if (track) track.hidden = false;
    if (fill) fill.style.width = state.progress + '%';
    if (text) text.textContent = state.message;
  }

  function refresh(opts) {
    opts = opts || {};
    var root = getRoot();
    if (!root || !window.FlorenzaFreeShipping) return;

    var cartTotal = typeof opts.cartTotal === 'number' ? opts.cartTotal : getCartTotal(root);
    root.setAttribute('data-cart-total', String(cartTotal));

    var cep = window.FlorenzaFreeShipping.digits(opts.cep || '');
    if (cep.length !== 8) {
      cep = window.FlorenzaFreeShipping.digits(root.getAttribute('data-customer-cep') || '');
    }
    if (cep.length !== 8) cep = window.FlorenzaFreeShipping.readCep();
    if (cep.length !== 8) {
      renderPending(root);
      return;
    }

    var applyUf = function (uf) {
      cache.cep = cep;
      cache.uf = uf;
      var state = window.FlorenzaFreeShipping.compute(cartTotal, uf);
      if (!state) {
        renderPending(root, 'Não foi possível calcular o frete grátis para este CEP.');
        return;
      }
      renderBar(root, state);
    };

    if (opts.uf) {
      applyUf(opts.uf);
      return;
    }
    if (cache.cep === cep && cache.uf) {
      applyUf(cache.uf);
      return;
    }

    renderPending(root, 'Consultando frete grátis...');
    window.FlorenzaFreeShipping.resolveUf(cep)
      .then(applyUf)
      .catch(function () {
        renderPending(root, 'Informe um CEP válido abaixo para calcular o frete grátis');
      });
  }

  window.FlorenzaMinicartFsb = { refresh: refresh };

  refresh();

  document.addEventListener('cart:updated', function (e) {
    var total = e && e.detail && typeof e.detail.total_price === 'number'
      ? e.detail.total_price
      : undefined;
    setTimeout(function () { refresh({ cartTotal: total }); }, 80);
  });
  document.addEventListener('ajaxCart.afterCartLoad', function () {
    setTimeout(function () { refresh(); }, 120);
  });
}

/**
 * /cart: atualiza quantidades via AJAX sem depender do botão "Atualizar sacola".
 * O ajax-cart troca input[type=number] por .js-qty (só altera o valor local),
 * então usamos delegação de eventos na linha do item.
 */
function initCartPageAutoUpdate() {
  var page = document.querySelector('.page-cart');
  if (!page) return;

  var updateWrap = page.querySelector('.cart-update');
  if (updateWrap) updateWrap.hidden = true;

  var debounceTimer = null;
  var busy = false;
  var pendingMeta = null;
  var checkoutInFlight = false;
  var releasingSubmit = false;
  var FLUSH_MS = 3000;

  function formatMoney(cents) {
    if (window.FlorenzaFreeShipping && typeof window.FlorenzaFreeShipping.formatMoney === 'function') {
      return window.FlorenzaFreeShipping.formatMoney(cents);
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var fmt = (window.theme && theme.moneyFormat) || window.money_format || undefined;
      return Shopify.formatMoney(cents, fmt);
    }
    var value = (Number(cents) || 0) / 100;
    try {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }
  }

  function cartRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  function cartChangeUrl() {
    return cartRoot() + 'cart/change.js';
  }

  function cartUpdateUrl() {
    return cartRoot() + 'cart/update.js';
  }

  function getItemRows() {
    var rows = Array.prototype.slice.call(page.querySelectorAll('tr.cart_item'));
    if (rows.length) return rows;
    return Array.prototype.slice.call(page.querySelectorAll('tbody tr')).filter(function (row) {
      return row.querySelector('.product-quantity');
    });
  }

  function getQtyInput(row) {
    return row.querySelector('.js-qty__num, [data-cart-qty], .product-quantity input');
  }

  function liveLine(row) {
    var index = getItemRows().indexOf(row);
    return index >= 0 ? index + 1 : 0;
  }

  function getMetaFromEl(el) {
    var row = el && el.closest ? el.closest('tr') : null;
    if (!row || !page.contains(row)) return null;

    var input = getQtyInput(row);
    var key = row.getAttribute('data-cart-key')
      || el.getAttribute('data-key')
      || (input && (input.getAttribute('data-key') || input.getAttribute('data-id')))
      || '';
    var line = liveLine(row);
    if (line < 1) {
      line = parseInt(
        row.getAttribute('data-cart-line')
        || el.getAttribute('data-line')
        || (input && input.getAttribute('data-line')),
        10
      );
    }
    if (isNaN(line) || line < 1) line = 0;

    var maxQty = parseInt(row.getAttribute('data-max-qty') || (input && input.getAttribute('max')), 10);
    if (isNaN(maxQty) || maxQty < 0) maxQty = null;

    return { row: row, input: input, key: key, line: line, maxQty: maxQty };
  }

  function parseQtyInput(raw) {
    var digits = String(raw == null ? '' : raw).replace(/\D/g, '');
    if (digits === '') return null;
    var qty = parseInt(digits, 10);
    if (isNaN(qty) || qty < 0) return null;
    return qty;
  }

  function getPersistedQty(meta) {
    if (!meta) return null;
    var fromRow = meta.row && parseInt(meta.row.getAttribute('data-persisted-qty'), 10);
    if (!isNaN(fromRow) && fromRow >= 0) return fromRow;
    var fromInput = meta.input && parseInt(meta.input.getAttribute('data-persisted-qty'), 10);
    if (!isNaN(fromInput) && fromInput >= 0) return fromInput;
    return null;
  }

  function setPersistedQty(meta, qty) {
    if (!meta) return;
    var value = String(qty);
    if (meta.row) meta.row.setAttribute('data-persisted-qty', value);
    if (meta.input) meta.input.setAttribute('data-persisted-qty', value);
  }

  function restoreEmptyQty(meta) {
    var restored = getPersistedQty(meta);
    if (restored === null || restored < 1) restored = 1;
    if (meta.input) meta.input.value = String(restored);
    return restored;
  }

  function showStockFeedback(row, message) {
    if (!window.FlorenzaToast) return;
    window.FlorenzaToast.show({
      title: 'Disponibilidade',
      text: message || 'Ajustamos a quantidade para o disponível em estoque.',
      duration: 5000
    });
  }

  function clearStockFeedback() {
    if (window.FlorenzaToast) window.FlorenzaToast.hide();
  }

  function findRowByKey(key) {
    if (!key) return null;
    var rows = getItemRows();
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-cart-key') === key) return rows[i];
    }
    return null;
  }

  function findCartItem(cart, meta) {
    var items = (cart && cart.items) || [];
    if (meta.key) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === meta.key) return items[i];
      }
    }
    if (meta.line > 0 && items[meta.line - 1]) return items[meta.line - 1];
    return null;
  }

  function stockMessage(maxQty) {
    if (maxQty === 0) return 'Este item está indisponível no momento.';
    if (maxQty === 1) return 'Disponível apenas 1 unidade deste item.';
    if (maxQty > 1) return 'Você pode levar até ' + maxQty + ' unidades deste item.';
    return 'Ajustamos a quantidade para o disponível em estoque.';
  }

  function syncCartThen(callback) {
    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateDomFromCart(cart);
        if (typeof callback === 'function') callback(cart);
      })
      .catch(function () {
        if (checkoutInFlight) {
          if (typeof callback === 'function') callback(null);
          return;
        }
        window.location.reload();
      });
  }

  function setBusy(state) {
    busy = state;
    page.classList.toggle('is-updating', state);
    getItemRows().forEach(function (row) {
      var input = getQtyInput(row);
      if (input) input.disabled = state;
      row.querySelectorAll('.js-qty__adjust, .qty_plus, .qty_minus').forEach(function (btn) {
        btn.style.pointerEvents = state ? 'none' : '';
      });
    });
  }

  function updateDomFromCart(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) {
      if (checkoutInFlight) return;
      window.location.reload();
      return;
    }

    var itemKeys = {};
    items.forEach(function (item) {
      itemKeys[item.key] = true;
    });

    getItemRows().forEach(function (row) {
      var key = row.getAttribute('data-cart-key');
      if (!key || !itemKeys[key]) row.remove();
    });

    items.forEach(function (item, index) {
      var row = findRowByKey(item.key);
      if (!row) return;

      row.style.opacity = '';
      row.style.pointerEvents = '';
      row.setAttribute('data-cart-line', String(index + 1));
      row.setAttribute('data-cart-key', item.key);

      var qtyInput = getQtyInput(row);
      if (qtyInput) {
        qtyInput.value = item.quantity;
        qtyInput.setAttribute('data-line', String(index + 1));
        qtyInput.setAttribute('data-key', item.key);
        qtyInput.setAttribute('data-id', item.key);
        qtyInput.setAttribute('data-persisted-qty', String(item.quantity));
        qtyInput.name = 'updates[' + item.key + ']';
        if (qtyInput.id) qtyInput.id = 'updates_' + item.key;
      }
      row.setAttribute('data-persisted-qty', String(item.quantity));

      var lineTotal = row.querySelector('.product-subtotal .amount, .product-subtotal');
      if (lineTotal) {
        var lineTarget = lineTotal.classList.contains('amount')
          ? lineTotal
          : (lineTotal.querySelector('.amount') || lineTotal);
        lineTarget.textContent = formatMoney(item.final_line_price);
      }

      var unitPrice = row.querySelector('.product-price .amount');
      if (unitPrice) unitPrice.textContent = formatMoney(item.final_price);

      var removeBtn = row.querySelector('[data-remove-cart-item], .product-remove .remove, .product-remove a');
      if (removeBtn) {
        removeBtn.setAttribute('data-line', String(index + 1));
        removeBtn.setAttribute('data-key', item.key);
        if (removeBtn.tagName === 'A') {
          removeBtn.setAttribute('href', '/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=0');
        }
      }
    });

    var cartTotal = page.querySelector('.cart-amount .amount')
      || page.querySelector('.total-checkout .amount');
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);

    var countEls = document.querySelectorAll('.enj-cartcount, .cartCount, .js-number-cart, [data-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = String(cart.item_count);
      if (el.hasAttribute('data-cart-count')) {
        el.setAttribute('data-cart-count', String(cart.item_count));
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    if (typeof jQuery !== 'undefined') {
      jQuery(document).trigger('cart:updated', [cart]);
    }
  }

  function restoreRow(row) {
    if (!row) return;
    row.style.opacity = '';
    row.style.pointerEvents = '';
  }

  function applyQuantity(meta, forcedQty) {
    if (!meta) return;
    if (busy) {
      pendingMeta = meta;
      if (forcedQty != null) pendingMeta.forcedQty = forcedQty;
      return;
    }

    var qty;
    if (forcedQty != null) {
      qty = forcedQty;
    } else if (meta.input) {
      qty = parseInt(String(meta.input.value).replace(/\D/g, ''), 10);
    } else {
      qty = 0;
    }
    if (isNaN(qty) || qty < 0) qty = 0;

    // Bloqueio antecipado quando conhecemos o estoque máximo
    if (forcedQty == null && meta.maxQty !== null && qty > meta.maxQty) {
      qty = meta.maxQty;
      if (meta.input) meta.input.value = String(Math.max(qty, 0));
      showStockFeedback(meta.row, stockMessage(meta.maxQty));
      if (meta.maxQty <= 0) return;
    } else if (meta.input) {
      meta.input.value = String(qty);
      clearStockFeedback(meta.row);
    }

    var requestedQty = qty;
    var line = liveLine(meta.row) || meta.line;
    var payload = { quantity: qty };
    // `line` (posição atual na tabela) é o parâmetro estável do /cart/change.js.
    if (line > 0) {
      payload.line = line;
    } else if (meta.key) {
      payload.id = String(meta.key);
    } else {
      restoreRow(meta.row);
      return;
    }

    setBusy(true);

    fetch(cartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        }).catch(function () {
          return { ok: res.ok, status: res.status, data: null };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var desc = result.data && (result.data.description || result.data.message);
          setBusy(false);
          syncCartThen(function (cart) {
            var row = findRowByKey(meta.key) || meta.row;
            var item = findCartItem(cart, meta);
            var maxAvailable = item ? item.quantity : meta.maxQty;
            showStockFeedback(row, stockMessage(maxAvailable) || desc);
          });
          return;
        }

        var cart = result.data;
        updateDomFromCart(cart);

        var item = findCartItem(cart, meta);
        var row = findRowByKey(meta.key) || meta.row;
        if (item && requestedQty > item.quantity) {
          if (row) row.setAttribute('data-max-qty', String(item.quantity));
          showStockFeedback(row, stockMessage(item.quantity));
        }

        setBusy(false);
        if (pendingMeta) {
          var next = pendingMeta;
          var nextForced = next.forcedQty;
          pendingMeta = null;
          applyQuantity(
            (next.input && getMetaFromEl(next.input)) || (next.row && getMetaFromEl(next.row)) || next,
            nextForced
          );
        }
      })
      .catch(function () {
        setBusy(false);
        if (checkoutInFlight) return;
        window.location.reload();
      });
  }

  function scheduleFromEl(el) {
    var meta = getMetaFromEl(el);
    if (!meta) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      applyQuantity(getMetaFromEl(meta.input) || meta);
    }, 350);
  }

  page.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty__adjust, .qty_plus, .qty_minus, .qtyplus, .qtyminus');
    if (!btn || !page.contains(btn)) return;
    setTimeout(function () {
      scheduleFromEl(btn);
    }, 20);
  });

  page.addEventListener('change', function (e) {
    if (!e.target.closest('.product-quantity')) return;
    if (!e.target.matches('input')) return;
    scheduleFromEl(e.target);
  });

  page.addEventListener('input', function (e) {
    if (!e.target.closest('.product-quantity')) return;
    if (!e.target.matches('input')) return;
    scheduleFromEl(e.target);
  });

  page.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.closest('.product-quantity')) return;
    if (!e.target.matches('input')) return;
    e.preventDefault();
    clearTimeout(debounceTimer);
    debounceTimer = null;
    applyQuantity(getMetaFromEl(e.target));
  });

  function isDirty() {
    return getItemRows().some(function (row) {
      var meta = getMetaFromEl(row);
      if (!meta) return false;
      var parsed = parseQtyInput(meta.input.value);
      if (parsed === null) return true;
      var persisted = getPersistedQty(meta);
      if (persisted === null) return true;
      return parsed !== persisted;
    });
  }

  function needsCheckoutIntercept() {
    return !!debounceTimer || busy || isDirty();
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('timeout'));
      }, ms);
      promise.then(function (value) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      }, function (err) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(err);
      });
    });
  }

  function waitWhileBusy(ms) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function tick() {
        if (!busy || Date.now() - start >= ms) {
          resolve();
          return;
        }
        setTimeout(tick, 40);
      })();
    });
  }

  function flushAllRows() {
    var updates = {};
    var count = 0;
    getItemRows().forEach(function (row) {
      var meta = getMetaFromEl(row);
      if (!meta || !meta.key) return;
      var qty = parseQtyInput(meta.input.value);
      if (qty === null) qty = restoreEmptyQty(meta);
      updates[meta.key] = qty;
      count += 1;
    });
    if (!count) return Promise.resolve(null);

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      }).catch(function () {
        return { ok: res.ok, data: null };
      });
    }).then(function (result) {
      if (result.ok && result.data) {
        updateDomFromCart(result.data);
      }
      return result;
    });
  }

  function submitCheckoutNative(form, submitter) {
    releasingSubmit = true;
    setBusy(false);
    var button = submitter || (form && form.querySelector('[name="checkout"]'));
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(button || undefined);
      return;
    }
    if (form && button && !form.querySelector('input[type="hidden"][name="checkout"]')) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = button.value || 'Checkout';
      form.appendChild(hidden);
    }
    if (form) HTMLFormElement.prototype.submit.call(form);
  }

  function onCheckoutSubmit(e) {
    if (releasingSubmit) return;
    if (!needsCheckoutIntercept()) return;

    e.preventDefault();
    var form = e.target;
    var submitter = e.submitter || form.querySelector('[name="checkout"]');
    checkoutInFlight = true;
    clearTimeout(debounceTimer);
    debounceTimer = null;

    var started = Date.now();
    waitWhileBusy(FLUSH_MS).then(function () {
      var remaining = Math.max(250, FLUSH_MS - (Date.now() - started));
      if (!isDirty()) return Promise.resolve();
      return withTimeout(flushAllRows(), remaining);
    }).then(function () {
      checkoutInFlight = false;
      submitCheckoutNative(form, submitter);
    }).catch(function () {
      checkoutInFlight = false;
      submitCheckoutNative(form, submitter);
    });
  }

  var cartForm = page.querySelector('form[action="/cart"]');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name && submitter.name !== 'checkout') return;
      onCheckoutSubmit(e);
    });
  }

  getItemRows().forEach(function (row) {
    var meta = getMetaFromEl(row);
    if (!meta) return;
    var initial = parseQtyInput(meta.input.value);
    if (initial === null) initial = 1;
    setPersistedQty(meta, initial);
  });
}

/**
 * Overlay de loading no minicart durante add/remove/qty.
 */
function initMinicartLoading() {
  var hideTimer = null;

  function getRoot() {
    return document.querySelector('.js-minicart') || document.querySelector('#cart-drawer .cart-drawer__content');
  }

  function ensureOverlay(root) {
    var el = root.querySelector('[data-minicart-loading]');
    if (el) return el;

    var wrap = root.querySelector('.relative') || root;
    el = document.createElement('div');
    el.className = 'minicart-loading';
    el.setAttribute('data-minicart-loading', '');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-busy', 'false');
    el.hidden = true;
    el.innerHTML = ''
      + '<div class="minicart-loading__box">'
      +   '<span class="minicart-loading__spinner" aria-hidden="true"></span>'
      +   '<span class="minicart-loading__text">Atualizando sacola...</span>'
      + '</div>';
    wrap.appendChild(el);
    return el;
  }

  function setLoading(on, label) {
    var root = getRoot();
    if (!root) return;
    var el = ensureOverlay(root);
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    root.classList.toggle('is-processing', !!on);
    el.hidden = !on;
    el.setAttribute('aria-busy', on ? 'true' : 'false');

    var text = el.querySelector('.minicart-loading__text');
    if (text && label) text.textContent = label;
  }

  window.FlorenzaMinicartLoading = {
    show: function (label) { setLoading(true, label); },
    hide: function () { setLoading(false); }
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('.remove-product')) {
      setLoading(true, 'Removendo item...');
      return;
    }
    if (e.target.closest('.minicart-qty-btn')) {
      setLoading(true, 'Atualizando sacola...');
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.minicart-qty-input')) {
      setLoading(true, 'Atualizando sacola...');
    }
  }, true);

  function hideSoon() {
    hideTimer = setTimeout(function () {
      setLoading(false);
    }, 180);
  }

  if (window.jQuery) {
    jQuery(document).on('submit.ajaxcart', 'form[action*="/cart/add"]', function () {
      setLoading(true, 'Adicionando à sacola...');
    });
    jQuery(document).on('cart:item-added', function () {
      setLoading(true, 'Adicionando à sacola...');
    });
    jQuery(document).on('ajaxCart.afterCartLoad cart:updated', hideSoon);
  } else {
    document.addEventListener('cart:item-added', function () {
      setLoading(true, 'Adicionando à sacola...');
    });
    document.addEventListener('ajaxCart.afterCartLoad', hideSoon);
    document.addEventListener('cart:updated', hideSoon);
  }
}

/* Drawer de filtros da coleção (mobile) */
function collectionFiltersDrawer() {
  const drawer = document.getElementById('collection-filters-drawer');
  const openBtn = document.querySelector('.js-filters-drawer-open');

  if (!drawer || !openBtn) return;

  const overlay = document.querySelector('.overlay-filter');
  const closeBtn = drawer.querySelector('.close_filter');

  function isOpen() {
    return drawer.classList.contains('active');
  }

  // O estado do drawer é a classe .active no próprio drawer: o overlay, o bloqueio
  // de scroll e o aria-expanded do botão são sincronizados a partir dela. Assim o
  // fechamento automático feito pelo AJAX dos filtros (hidePopup) também é refletido.
  function syncState() {
    const open = isOpen();
    if (overlay) overlay.classList.toggle('active', open);
    document.body.classList.toggle('filters-drawer-open', open);
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  openBtn.addEventListener('click', function () {
    drawer.classList.add('active');
    syncState();
  });

  function close() {
    drawer.classList.remove('active');
    syncState();
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  new MutationObserver(syncState).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
  });
}
